var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 10.5001C1 15.7683 5.23185 20.0001 10.5001 20.0001C15.7683 20.0001 20.0001 15.7683 20.0001 10.5001C20.0001 5.23185 15.7683 1 10.5001 1C5.23185 1 1 5.23185 1 10.5001Z",
    stroke: "#7E8EAA",
    strokeWidth: 1.5,
    strokeMiterlimit: 23.3333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6591 14.8181H11.3636C10.8454 14.8181 10.5 14.4727 10.5 13.9545V8.34082C10.5 8.08173 10.3273 7.909 10.0682 7.909H8.77271",
    stroke: "#7E8EAA",
    strokeWidth: 1.5,
    strokeMiterlimit: 23.3333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.241 5.75C10.1547 5.75 9.98193 5.83636 9.98193 6.00909C9.98193 6.18182 10.1547 6.18182 10.241 6.18182C10.3274 6.18182 10.5001 6.09546 10.5001 5.92273C10.5001 5.75 10.4138 5.75 10.241 5.75Z",
    stroke: "#7E8EAA",
    strokeWidth: 1.5,
    strokeMiterlimit: 23.3333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/Info.edf94ab6c072b01ea3a4373ab316ddce.svg";
export { ForwardRef as ReactComponent };